import { Alert, AlertBody, Stack } from 'component-library';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import { BetaPill } from '@/components/Pill/BetaPill';
import { Icon } from '@/components/widgets/a/Icon/Icon';
import { usePathSet } from '@/hooks/usePathSet';
import { SignedInPageLayout } from '@/layout/signed-in-page';
import { useMenuItems } from '@/pages/shared/hooks/useMenuItems';
import { useDisplayInSituPages } from '@/pages/shared/uploads/hooks/useDisplayUploadsPage';
import { buildPath } from '@/utils/buildPath';

import { InSituDataCards } from './components/InSituDataCards';

export const InSituDataPage = () => {
  const { t } = useTranslation();
  const menuItems = useMenuItems();
  const pathSet = usePathSet();

  const { displayInSituDataUploadPage } = useDisplayInSituPages();

  if (!displayInSituDataUploadPage) {
    return <Navigate to={pathSet.home} replace />;
  }

  return (
    <SignedInPageLayout
      items={menuItems}
      navBarProps={{
        title: (
          <Stack direction='row' spacing={4} centerMain>
            {t('navbar.insituData')} <BetaPill />
          </Stack>
        ),
        backPath: buildPath(pathSet.uploads),
      }}
    >
      <Stack spacing={8} direction='row' className='flex-wrap w-full'>
        <Alert type='warning' className='w-full'>
          <AlertBody>
            <Icon icon='ri-error-warning-line' className='text-lg mr-2' />
            {t('shared.insituDataUpload.newConfig.labels.warningMessage')}
          </AlertBody>
        </Alert>
        <InSituDataCards />
      </Stack>
    </SignedInPageLayout>
  );
};
